<template>
<div id="ihealth-layout" class="theme-tradewind">

<!-- main body area -->
<div class="main p-2 py-3 p-xl-5">
    
    <!-- Body: Body -->
    <div class="body d-flex p-0 p-xl-5">
        <div class="container-xxl">

            <div class="row g-0">
                <div class="col-lg-6 d-none d-lg-flex justify-content-center align-items-center rounded-lg auth-h100">
                    <div style="max-width: 25rem;">
                        <div class="text-center mb-5">
                              <i class="icofont-heart-beat secondary-color" style="font-size: 90px;"></i>
                        </div>
                        <div class="mb-5">
                            <h2 class="color-900 text-center">I-Health, We aim to make your life better</h2>
                        </div>
                        <!-- Image block -->
                        <div class="">
                            <img src="../assets/images/login-img.svg" alt="login-img">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 d-flex justify-content-center align-items-center border-0 rounded-lg auth-h100">
                    <div class="w-100 p-3 p-md-5 card border-0 bg-dark text-light" style="max-width: 32rem;">
                     
                      <!-- Form -->
                      <form @submit.prevent="changePassword" class="row g-1 p-3 p-md-4">
                        <div class="col-12 text-center mb-5">
                          <img src="../assets/images/forgot-password.svg" class="w240 mb-4" alt="" />
                          <h1>Şifrəniz yaddan çıxıb?</h1>
                          <span>Sizin nömrənizə OTP kod göndərilmişdir. Zəhmət olmasa, həmin kodu və yeni şifrəni daxil edin.</span>
                        </div>

                        <!-- OTP -->
                        <div class="col-12">
                          <div class="mb-2">
                            <label class="form-label">OTP</label>
                            <input v-model="otp" v-validate="{ required: true, digits: 4}" name="otpfield" type="text" class="form-control form-control-lg" placeholder="1234">
                            <span class="inputError">{{ errors.first('otpfield') }}</span>
                          </div>
                        </div>

                        <!-- New Password -->
                        <div class="col-12">
                          <div class="mb-2">
                            <label class="form-label">New Password</label>
                            <input v-model="newPassword" v-validate="{ required: true, min: 4}" name="newpasswordfield" type="text" class="form-control form-control-lg" placeholder="new password">
                            <span class="inputError">{{ errors.first('newpasswordfield') }}</span>
                          </div>
                        </div>

                        <!-- Change the password -->
                        <div class="col-12 text-center mt-4">
                          <button type="submit" :disabled="loading" class="btn btn-lg btn-block btn-light lift">Şifrəni dəyiş</button>
                        </div>
                      </form>
                      <!-- End Form -->
                        
                    </div>
                </div>
            </div> <!-- End Row -->
        </div>
    </div>

</div>

</div>
</template>

<script>
import axios from "axios"
import store from '../store/'

export default {  
  name: 'ForgotPassword',
  props: {
    msisdn: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      otp: '',
      newPassword: '',
      loading: false
    }
  },
  methods: {
    async changePassword() {
      const validForm = await this.isFormValid()
      if (validForm) {
        this.loading = true

        axios.post(store.getters.getUrl+'/Auth/reset-password', {msisdn: this.msisdn, otpCode: parseInt(this.otp), newPassword: this.newPassword})
        .then(() => {
          this.$toast.success("Parol dəyişdirildi")
          this.loading = false;
          this.$router.push('/login')
        })
        .catch(error => {
          if (error.response.status === 403)
            this.$toast.error("OTP səhvdir!")
          else
            this.$toast.error("Serverdə səhvlik baş verdi!")
        })

        this.loading = false
      } 
      else {
        this.$toast.error('Səvhlikləri düzəldin!')
        this.loading = false
      }
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    }
  },
  created() {
    if (!this.msisdn) {
      this.$router.push('/login')
    }

    axios.post(store.getters.getUrl+'/Auth/send-code', {msisdn: this.msisdn})
    .then(response => {
      console.log(response.status)
    })
    .catch(() => this.$router.push('/login'))
  }
}
</script>